
/**
 * 미디어 파일 유형
 */
export type UploadMediaBodyType = typeof UploadMediaBodyType[keyof typeof UploadMediaBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UploadMediaBodyType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
  AUDIO: 'AUDIO',
} as const;
